module.exports = __webpack_public_path__ + "img/icon_integrador_de_dados.41d5a886.svg";